import * as _ from 'lodash';
import {
    IDENTIFIERS_LOAD_SUCCESS, IDENTIFIERS_SAVE_SUCCESS,
    IDENTIFIER_ADD_SUCCESS, IDENTIFIER_DELETE_SUCCESS,
    IDENTIFIER_DUPLICATE_SUCCESS,
    IDENTIFIER_DUPLICATE, IDENTIFIERS_SAVE, IDENTIFIER_DELETE, IDENTIFIER_DELETE_ERROR, IDENTIFIERS_SAVE_ERROR, IDENTIFIERS_REORDER, IDENTIFIERS_REORDER_SUCCESS, IDENTIFIERS_REORDER_ERROR, IDENTIFIERS_LOAD
} from './identifiers.constants';
import { StoreItem } from '../Store';
import { Identifier, Group } from '../../models';
import { GROUP_DELETE_SUCCESS } from '../groups/groups.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { toDictionary } from '../../common';

export function identifiersReducer(state: StoreItem<Identifier> = new StoreItem<Identifier>(), action: { type: string, payload: any }) {
    let newState = state;
    if (action && action.type) {
        const { payload } = action;
        switch (action.type) {
            case IDENTIFIERS_LOAD:
                newState = {
                    dictionary: state.dictionary,
                    isLoading: true,
                    isLoaded: false,
                    hasError: false,
                    error: null
                };
                break;
            case IDENTIFIERS_LOAD_SUCCESS:
                newState = {
                    dictionary: toDictionary(action.payload),
                    isLoading: false,
                    isLoaded: true,
                    hasError: false,
                    error: null
                };
                break;
            case IDENTIFIER_DUPLICATE_SUCCESS:
            case IDENTIFIER_ADD_SUCCESS:
                newState = new StoreItem<Identifier>();
                for (const key of Object.keys(state)) {
                    newState[key] = state[key];
                }
                newState.dictionary[payload.identifier.guid] = payload.identifier;
                newState.isLoading = false;
                newState.isLoaded = true;
                break;
            case IDENTIFIERS_SAVE:
            case IDENTIFIER_DUPLICATE:
            case IDENTIFIERS_REORDER:
                newState = new StoreItem<Identifier>();
                newState.isLoading = true;
                newState.dictionary = state.dictionary;
                break;
            case IDENTIFIERS_REORDER_SUCCESS:
            case IDENTIFIERS_SAVE_SUCCESS:
                const { identifiers } = action.payload;
                const newDic = {};
                const existing = _.values(state.dictionary) as Identifier[];
                existing.forEach(element => {
                    newDic[element.guid] = _.find(identifiers, (i: Identifier) => i.guid === element.guid) || element;
                });
                identifiers
                    .filter(i => !newDic[i.guid])
                    .forEach(i => newDic[i.guid] = i);
                newState = {
                    dictionary: newDic,
                    isLoading: false,
                    isLoaded: true,
                    hasError: false,
                    error: null
                };
                break;
            case IDENTIFIER_DELETE:
                newState = new StoreItem<Identifier>();
                for (const key of Object.keys(state)) {
                    newState[key] = state[key];
                }
                newState.isLoading = true;
                break;
            case IDENTIFIER_DELETE_SUCCESS:
                newState = new StoreItem<Identifier>();
                for (const key of Object.keys(state)) {
                    newState[key] = state[key];
                }
                const dictionary = {};
                for (const key of Object.keys(newState.dictionary)) {
                    dictionary[key] = newState.dictionary[key];
                }
                newState.dictionary = dictionary;
                delete dictionary[payload.guid];
                newState.isLoading = false;
                break;
            case IDENTIFIERS_SAVE_ERROR:
            case IDENTIFIER_DELETE_ERROR:
            case IDENTIFIERS_REORDER_ERROR:
                newState = new StoreItem<Identifier>();
                for (const key of Object.keys(state)) {
                    newState[key] = state[key];
                }
                newState.isLoading = false;
                newState.hasError = true;
                break;
            case GROUP_DELETE_SUCCESS:
                newState = new StoreItem<Identifier>();
                for (const key of Object.keys(state)) {
                    newState[key] = state[key];
                }
                (action.payload as Group).identifierCollection.forEach(i => {
                    delete newState.dictionary[i.guid];
                });
                newState.isLoading = false;
                break;
            case APPLICATION_DISCONNECTED:
                newState = new StoreItem<Identifier>();
                break;
        }
    }
    return newState;
}